import React from 'react';

import { SimpleTag as Tag } from '@atlaskit/tag';

const cupcakeipsum = 'Croissant tiramisu gummi bears.';

export default (): React.JSX.Element => <Tag text={cupcakeipsum} />;
